import React from "react";
import costStatus from "../../conf/words";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import SubCostListComponents from "./SubCostListComponents";

class CostListComponents extends React.Component {
  constructor(props) {
    super(props);
    const {t} = props
    this.state = {
      subRowShow: false,
      subRowShowButtonIcon: "fa-chevron-circle-up",
      tooltipText: <Tooltip id="tooltip">{t('revisedCost')}</Tooltip>,
      attachmentText: <Tooltip id="tooltip">{t('costPhotoExist')}</Tooltip>,
      cancellationRequestText: <Tooltip id="tooltip">{t('awaitingConfirmationForCancellation')}</Tooltip>,
    }
  }

  subRowShowButton() {
    let { subRowShow, subRowShowButtonIcon } = this.state;
    if (subRowShow) {
      subRowShow = false;
      subRowShowButtonIcon = "fa-chevron-circle-up";
    } else {
      subRowShow = true;
      subRowShowButtonIcon = "fa-chevron-circle-down";
    }
    this.setState({
      subRowShow: subRowShow,
      subRowShowButtonIcon: subRowShowButtonIcon
    })
  }
  render() {
    let { subRowShow, subRowShowButtonIcon } = this.state;
    let { group, employeeInfo, t } = this.props;
    const groupId = group.firstCost.invoiceNo;
    if (!group.firstCost.cancellationRequest)
      group.firstCost.cancellationRequest = { now: false };
    let isPdfShowForSub =  ( group.subCost && group.subCost.filter(s => s.status === "accounting" || s.status === "completed").length > 0 ) || false;
    return (
      <div className="div-table-row">
        <div className="first-row">
          <div className="row">
            <div className="col-md-1 div-table-column">
              <span className="icons">
                <i id={"costListCostSublistButton-" + groupId} onClick={() => { this.subRowShowButton() }} className={"show-subrow fa " + subRowShowButtonIcon} aria-hidden="true"></i>
                {
                  group.firstCost.revisions ?
                    <OverlayTrigger placement="bottom" overlay={this.state.tooltipText}>
                      <i className="fa fa-star star-color" aria-hidden="true"></i>
                    </OverlayTrigger>
                    : null
                }
                {
                  group.firstCost.costPhotos.length > 0
                    ?
                    <OverlayTrigger placement="bottom" overlay={this.state.attachmentText}>
                      <i className="fa fa-paperclip star-color" aria-hidden="true"></i>
                    </OverlayTrigger>
                    :
                    null
                }
                {
                  group.firstCost.cancellationRequest.now
                    ?
                    <OverlayTrigger placement="bottom" overlay={this.state.cancellationRequestText}>
                      <i className="fa fa-ban star-color" aria-hidden="true"></i>
                    </OverlayTrigger>
                    :
                    null
                }
              </span>
            </div>
            <div id={"costListInvoiceNo-" + groupId} className="col-md-1 div-table-column">
              <h5>{group.firstCost.invoiceNo}</h5>
            </div>
            <div id={"costListCostType-" + groupId} className="col-md-2 div-table-column">
              <h5>{group.firstCost.costType}</h5>
            </div>
            <div id={"costListCostDate-" + groupId} className="col-md-2 div-table-column">
              <h5>{group.firstCost.costDate}</h5>
            </div>
            <div id={"costListCostAmount-" + groupId} className="col-md-1 div-table-column">
              <h5>{group.firstCost.costAmount} {new window.Money(group.firstCost.moneyType).getMoneySymbol()}</h5>
            </div>
            <div id={"costListCostStatus-" + groupId} className="col-md-2 div-table-column">
              <span className="pending warning-write">{t(group.firstCost.status)}</span>
            </div>
            <div className="col-md-3">
              {
                group.firstCost.status != "completed"
                  ?
                  <input type="submit" id={"costListCostUpdateButton-" + groupId} onClick={() => { this.props.editCost(group.firstCost) }} value={t("edit")} className="btn btn-danger btn-fill btn-wd customBtn" />
                  :
                  <button type="button" id={"costListCostInfoButton-" + groupId} onClick={() => { this.props.editCost(group.firstCost) }} className="btn btn-wd btn-info btn-fill btn-rotate actionBtn">
                    <span className="btn-label"><i className="fa fa-info"></i></span>
                  </button>
              }
              {group.firstCost.status == "waiting" ? <div style={{ display: "inline-block" }}> &nbsp;
              <button type="button" id={"costListCostSendApprovalButton-" + groupId} onClick={() => { this.props.costSendToApproval(group.firstCost, true) }} className="btn btn-primary btn-fill btn-wd actionBtn">
                  <span className="btn-label"><i className="fa fa-paper-plane"></i></span>
                </button>
              </div> : null}
              {
                (group.firstCost.status == "manager" || group.firstCost.status == "accounting" || group.firstCost.status == "waiting") && (!group.firstCost.cancellationRequest || !group.firstCost.cancellationRequest.now)
                  ?
                  <span>
                    &nbsp;
                  <button type="button" id={"costListCostCancelButton-" + groupId} onClick={() => { this.props.deleteCostAction(group.firstCost.costId) }} className="btn btn-wd btn-danger actionBtn"><span className="btn-label"><i className="fa fa-times"></i></span></button>
                  </span>
                  :
                  null
              }
              {
                group.firstCost.transactions
                  ?
                  <span>
                    &nbsp;
                  <button type="button" id={"costListCostTransactionsButton-" + groupId} onClick={() => { this.props.transactionsButton(group.firstCost) }} className="btn btn-wd btn-default actionBtn">
                      <span className="btn-label"><i className="fa fa-cogs"></i></span></button>
                  </span>
                  :
                  null
              }
             &nbsp;
             {
                group.firstCost.status == "accounting" || group.firstCost.status == "completed" || isPdfShowForSub || (employeeInfo.masrafYoneticiOnayiBeklemedenPdfIndirebilsinMi == "true" ? group.firstCost.status == "manager" : false)
                  ?
                  <button type="button" id={"costListCostDownloadButton-" + groupId} onClick={() => { this.props.pdfDownloadButton(group.firstCost) }} className="btn btn-primary btn-fill btn-wd actionBtn">
                    <span className="btn-label"><i className="fa fa-download"></i></span>
                  </button>
                  :
                  null
              }
            </div>
          </div>
        </div>
        <div className="div-table-subrow" style={{ display: subRowShow ? "block" : "none" }}>
          {
            group.subCost.length > 0
              ?
              group.subCost.map((subCost, key) => {
                return <SubCostListComponents t={t} key={key} subCost={subCost} transactionsButton={(param) => { this.props.transactionsButton(param) }} editCost={(param) => { this.props.editCost(param) }} costSendToApproval={(param) => { this.props.costSendToApproval(param) }} deleteCostAction={(param) => { this.props.deleteCostAction(param) }} />
              })
              :
              null
          }
        </div>
      </div>
    );
  }
}

export default CostListComponents;
